
import ARRAY from "../../../UTIL/ARRAY";
import CONQUER from "../../CONQUER";
import GameInstance from "../GameInstance";
import LOG, { log } from "../../../UTIL/LOG";
import { ACTIONS } from "../../../Models/ENUM";
import TurnsInstance from "../TURNS/TurnsInstance";

class Score
{
    private conquer         : CONQUER;
    private gameInstance    : GameInstance;

    public multiplier       : number = 1;
    public permanentMultiplier : number = 1;

    private meVar           : string = "PlayerScore";
    private rivalVar        : string = "RivalScore";

    public vars             : any = {};
    public color            : string = "";
    private query           : any;
 
    constructor( gameInstance:GameInstance )
    {
        this.conquer        = gameInstance.conquer;
        this.gameInstance   = gameInstance;
        this.conquer        = gameInstance.conquer;

        this.query          = { gameID:gameInstance.gameID };
    }
 
    public reset()
    {
        this.conquer.Avatars.ME.vars.score = 0;

        this.vars = {};
        this.resetMultiplier();
        this.set(0);
        this.setRival(0);
    }

    public setVars( vars:any )
    {
        this.vars = vars;
    };

    /*=======================


    ME


    ========================*/

    public setPermanentMultiplier( value:number=1 )
    {
        this.permanentMultiplier = value;
    };
 
    public increaseMultiplier( value:number=1 )
    {
        this.setMultiplier( this.multiplier + value );
    };

    public resetMultiplier()
    {
        this.setMultiplier(1);
    };

    public setMultiplier( value:number=1 )
    {
        this.multiplier = value;
        this.color = this.getColor();

        if( this.multiplier === 1 )
        {
            this.gameInstance.Signal.set( "ACTIVEFX:Remove", { id:"ScoreMultiplier" });
            return;
        }

        this.gameInstance.Signal.set( "ACTIVEFX:Set", { id:"ScoreMultiplier", text:"X"+this.multiplier });
    };

    private getColor()
    {
        if( this.multiplier > 3 ) return "RED";
        if( this.multiplier > 2 ) return "GREEN";
        if( this.multiplier > 1 ) return "YELLOW";
 
        return "WHITE";
    }

    public increase( value:number=1, avatarID?:any )
    {
        if( avatarID ) return this.increaseAvatar( value, avatarID );

        this.conquer.Haptic.short();

        value = value * this.multiplier * this.permanentMultiplier;
 
        this.set( ( this.conquer.Avatars.ME.vars.score || 0 ) + value );
 
        this.gameInstance.Signal.set( "PlayerScoreIncrease", value );
  
    };

    public set( score:number, avatarID?:any ) 
    {
        if( avatarID ) return this.setAvatar( score, avatarID );

        this.conquer.Avatars.ME.vars.score = this.gameInstance.Data.display( this.meVar, score );

        this.gameInstance.Data.setMax( this.meVar, score );

        this.gameInstance.Signal.set( "SCORE:onUpdate" );
        this.gameInstance.Data.display( "SCORE:"+ this.conquer.Avatars.ME.avatarID, score );
    }

    public get( avatarID?:any ) 
    {
        if( avatarID ) return this.getAvatar( avatarID );

        return this.gameInstance.Data.get( this.meVar );
    }

    public isWinning()
    {
        return this.get() > this.getRival();
    };
    
    /*=======================


    AVATARS


    ========================*/
 
    public increaseAvatar( value:number=1, avatarID:any ) : any
    {
        if( avatarID == this.conquer.Avatars.ME.avatarID ) return this.increase( value );

        let Avatar = this.conquer.Avatars.data[ avatarID ];
        if( !Avatar ) return value; 

        return this.setAvatar( ( Avatar.vars.score || 0 ) + value, avatarID );
    };
    

    public setAvatar( score:number, avatarID:any ) : any  
    {
        if( avatarID == this.conquer.Avatars.ME.avatarID ) return this.set( score );

        let Avatar = this.conquer.Avatars.data[ avatarID ];

        if( !Avatar ) return; 
 
        Avatar.vars.score = score;

        this.gameInstance.Data.display( "SCORE:"+ avatarID, score );
 
        return score;
    }

    public getAvatar( avatarID:any ) : any
    {
        if( avatarID == this.conquer.Avatars.ME.avatarID ) return this.get();

        let Avatar = this.conquer.Avatars.data[ avatarID ];
        if( !Avatar ) return; 

        return Avatar.vars.score;
    }












    public toCoins( multiplier:any )
    {
        if( !multiplier ) return;
        
        this.gameInstance.Coins.setPermanentMultiplier(1);
        this.gameInstance.Coins.increase( Math.round( this.get() * multiplier ) );
    };
 
    /*=======================


    RIVAL


    ========================*/


    public increaseRival( value:number )
    {
        this.setRival( this.gameInstance.Data.get( this.rivalVar ) + ( value || 1 ) );
    };

    public getRival()
    {
        return this.gameInstance.Data.get( this.rivalVar );
    };

    public setRival( value:number )
    {
        this.gameInstance.Data.display( this.rivalVar, value );
        
        if( this.gameInstance.Rivals.RIVAL ) this.gameInstance.Rivals.RIVAL.vars.score = value;

        this.gameInstance.Signal.set( "SCORE:onUpdate" );
        return value;
    };

    /*=======================


    RIVAL


    ========================*/

    public save()
    {
        let score : number = this.get();

        this.gameInstance.Scoreboard.set( score );

        let turnsInstance : TurnsInstance = this.gameInstance.Turns.selected;
 
        if( turnsInstance )
        {
            let turnData : any = { score:score };
            if( this.permanentMultiplier > 1 ) turnData.permanentMultiplier = this.permanentMultiplier;
            turnsInstance.set( { turnData:turnData } );
        }
  
    }

     /*=======================


    GET


    ========================*/

    public async getOne() : Promise<any>
    {
        let value = await this.conquer.do( ACTIONS.GAME_SCORE_GET, this.query );
        return Promise.resolve( value );
    }

    public async getAllTime() : Promise<any>
    {
        let values = await this.conquer.do( ACTIONS.GAME_SCORE_GETALLTIME, this.query );
        return Promise.resolve( values );
    };

    public async getToday() : Promise<any>
    {
        let values = await this.conquer.do( ACTIONS.GAME_SCORE_GETTODAY, this.query );
        return Promise.resolve( values );
    };

    public async getFriendsAllTime() : Promise<any>
    { 
        let values = await this.conquer.do( ACTIONS.GAME_SCORE_GETFRIENDSALLTIME, this.query );
        return Promise.resolve( values );
    };

    public async getFriendsToday() : Promise<any>
    {
        let values = await this.conquer.do( ACTIONS.GAME_SCORE_GETFRIENDSTODAY, this.query );
        return Promise.resolve( values );
    };

};

export default Score;